import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, CopyButton as MantineCopyButton, rem, Stack, Text, Textarea, TextInput, ThemeIcon, Title } from "@mantine/core";
import { AppModal } from "../../shared/AppModal";
import { useForm, yupResolver } from "@mantine/form";
import { CheckCircleOutline, LinkOutlined } from "@mui/icons-material";
import { useState } from "react";
import { ImagePrefixEnum, useGetOrganizationImageUrlQuery, useSendPriorityPublicInviteMutation } from "../../graphql/graphql";
import { ImageWithPlaceholder } from "../../shared/ImageWithPlaceholder";
import { showErrorNotification, showSuccessNotification } from "../../shared/Notifications";
import { PriorityPublicInviteInitialValues, PriorityPublicInviteSchema } from "./PriorityPublicInviteModal.validation";
export const PriorityPublicInviteModal = ({ opened, close }) => {
    const [{ fetching: creatingPublicInvite }, createPublicInvite] = useSendPriorityPublicInviteMutation();
    const [inviteResult, setInviteResult] = useState(null);
    const form = useForm({
        mode: "controlled",
        initialValues: PriorityPublicInviteInitialValues,
        validate: yupResolver(PriorityPublicInviteSchema)
    });
    const [{ data: organizationData }] = useGetOrganizationImageUrlQuery({
        pause: !opened
    });
    const submitPublicInvite = async (event) => {
        event.preventDefault();
        const valid = form.validate();
        if (valid.hasErrors)
            return;
        createPublicInvite({ ...form.values })
            .then((result) => {
            const data = result.data?.priorityInvites?.createPriorityInvite;
            if (data) {
                setInviteResult({
                    email: data.email,
                    inviteUrl: data.inviteUrl
                });
                showSuccessNotification("Invitation sent!");
            }
        })
            .catch((error) => {
            console.error("An error occurred.", error);
            showErrorNotification();
        });
    };
    const handleClose = () => {
        close();
        form.reset();
        setInviteResult(null);
    };
    return (_jsx(AppModal, { title: _jsxs("div", { style: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "1rem"
            }, children: [_jsx(ImageWithPlaceholder, { prefix: ImagePrefixEnum.Avatars, imageUrl: organizationData?.organizations?.organization
                        ?.imageUrl, size: 50 }), _jsx(Title, { order: 5, lineClamp: 1, children: inviteResult
                        ? "Invitation Sent"
                        : "Send Invitation to Onboarding Form" })] }), opened: opened, onClose: handleClose, children: inviteResult ? (_jsxs(Stack, { gap: "md", children: [_jsxs(Stack, { align: "center", gap: "xs", py: "md", children: [_jsx(ThemeIcon, { size: 56, radius: "xl", color: "teal", variant: "light", children: _jsx(CheckCircleOutline, { style: { width: rem(32), height: rem(32) } }) }), _jsx(Text, { size: "sm", c: "dimmed", children: "Invitation sent to" }), _jsx(Title, { order: 4, children: inviteResult.email })] }), _jsxs(Flex, { justify: "flex-end", gap: "sm", children: [_jsx(Button, { variant: "subtle", color: "gray", onClick: handleClose, children: "Done" }), _jsx(MantineCopyButton, { value: inviteResult.inviteUrl, children: ({ copied, copy }) => (_jsx(Button, { variant: "filled", color: copied ? "teal" : undefined, leftSection: copied ? (_jsx(CheckCircleOutline, { style: { width: rem(16) } })) : (_jsx(LinkOutlined, { style: { width: rem(16) } })), onClick: copy, children: copied
                                    ? "Link Copied!"
                                    : "Copy Invite Link" })) })] })] })) : (_jsxs(Stack, { gap: "md", children: [_jsx(TextInput, { required: true, "data-autofocus": true, label: "Email", placeholder: "Send onboarding form to...", ...form.getInputProps("email") }), _jsx(Textarea, { label: "Note", placeholder: "(Optional) \nThis note will appear in the onboarding invitation email...", autosize: true, minRows: 4, maxRows: 20, ...form.getInputProps("note") }), _jsx(Flex, { justify: "flex-end", children: _jsx(Button, { variant: "filled", loading: creatingPublicInvite, onClick: submitPublicInvite, children: "Send" }) })] })) }));
};
